// The one way a page writes a date or a date-time: 25 Sep 2026, and 25 Sep 2026, 14:05.
// A missing value is an em dash, so an empty cell never reads as a date.

type DateLike = string | Date | null | undefined;

const valid = (v: DateLike): Date | null => {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

export function fmtDate(v: DateLike): string {
  const d = valid(v);
  return d ? d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—";
}

export function fmtDateTime(v: DateLike): string {
  const d = valid(v);
  return d ? d.toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
}
